export const getFileName = function (callback, name) {
  return callback(`./${ name }`);
}
export const getFileList = function (callback) {
  let imagesList = []
  callback.keys().forEach(element => {
      imagesList.push(callback(element))
  });
  return imagesList;
}